<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="breadcrumbs" :class="classNames">
    <ol>
      <li>
        <router-link :to="countyLink(0, {year: this.year})">Norge</router-link>
      </li>
      <li v-if="municipality || county">
        <router-link :to="countyLink(county.id, {year: this.year})">{{ county.name }}</router-link>
      </li>
      <li v-if="municipality">
        <router-link :to="municipalityLink(municipality.id, {year: this.year})">{{ municipality.name }}</router-link>
      </li>
    </ol>

    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.breadcrumbs {
  ol {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;

    li {
      margin: 0;
      padding: 0;
      margin-right: 0.5em;
      display: flex;
      align-items: center;

      a {
        display: block;
        margin: 2px;
        padding: 0.5em;
        cursor: pointer;
        white-space: nowrap;
        color: inherit;
        text-decoration: none;
      }
    }
  }

  &--hidden > ol {
    visibility: hidden;
  }

  &--spaced {
    li {
      &:not(:last-child) {
        &::after {
          content: '|';
        }
      }

      &:last-child > a {
        color: $font-color !important;
      }
    }
  }

  &--bordered {
    li {
      border: $breadcrumb-border;

      &:last-child > a {
        background-color: $breadcrumb-background;
      }
    }
  }
}

@media (min-width: $responsive-break) {
  .breadcrumbs {
    display: flex;
    align-items: center;

    & > div {
      flex: 1 1;
    }
  }
}
</style>

<script>
export default {
  props: {
    year: Number,
    county: Object,
    municipality: Object,
    borders: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classNames () {
      const visible = this.county || this.municipality

      return `breadcrumbs--${this.borders ? 'bordered' : 'spaced'} breadcrumbs--${visible ? 'visible' : 'hidden'}`
    }
  }
}
</script>
